import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import { TextField, MenuItem } from "@material-ui/core";
import { cancelar } from "../crud/contrato.crud";
import Swal from "sweetalert2";
import { textoExclusao, listaMotivosTipo } from "../utils/Utils";

export default class ModalCancelarContrato extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: null,
            submitted: false,
            motivo: "",
            motivo_tipo: "",
            data_de_cancelamento: ""
        };
    }

    onSubmit = () => {
        if (this.state.motivo_tipo.trim() === "") {
            return Swal.fire("Ops!", "Selecione o tipo de motivo do cancelamento.", "error");
        }

        if (this.state.motivo.trim() === "") {
            return Swal.fire("Ops!", "Informe o motivo do cancelamento.", "error");
        }

        if (this.state.data_de_cancelamento.trim() === "") {
            return Swal.fire("Ops!", "Informe a data de cancelamento.", "error");
        }

        if (this.props?.array_id_contratos?.length === 0) {
            return Swal.fire("Ops!", "Selecione pelo menos um contrato para cancelar.", "error");
        }

        Swal.fire({ ...textoExclusao, text: `Deseja realmente cancelar?` }).then((result) => {
            if (result.value) {
                this.setState({ submitted: true });

                cancelar({
                    motivo: this.state.motivo,
                    motivo_tipo: this.state.motivo_tipo,
                    data_de_cancelamento: this.state.data_de_cancelamento,
                    array_contratos: this.props.array_id_contratos
                })
                    .then((res) => {
                        if (!res.data?.errors) {
                            Swal.fire("Sucesso!", "Contrato(s) cancelado(s) com sucesso.", "success");

                            this.setState({ motivo: "", motivo_tipo: "" });

                            this.props.setOpen(false);

                            if (this.props.after) {
                                this.props.after();
                            }
                        } else {
                            Swal.fire("Ops!", res.data?.errors?.[0] ?? "Parece que houve um problema. Por favor, entre em contato com o suporte.", "error");
                        }
                    })
                    .catch((err) => Swal.fire("Ops!", err?.response?.data?.errors[0] ?? "Parece que houve um problema. Por favor, entre em contato com o suporte.", "error"))
                    .finally(() => this.setState({ submitted: false }));
            }
        });
    };

    render() {
        const { open, setOpen } = this.props;

        return (
            <Modal show={open} size={"xl"} centered onHide={() => setOpen(false)} style={{ padding: "0 !important" }}>
                <Modal.Header closeButton>
                    <Modal.Title className="tt-14 color-gray-100 semibold">{"Inativar contrato(s)"}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="row py-4">
                        <div className="col-sm-12">
                            <p className="texto-modal">Adicione o motivo do cancelamento do(s) contrato(s).</p>
                        </div>

                        <div className="col-sm-12">
                            <TextField
                                select
                                label="Tipo de motivo *"
                                margin="normal"
                                variant="outlined"
                                value={this.state.motivo_tipo}
                                onChange={(e) => this.setState({ motivo_tipo: e.target.value })}
                            >
                                {[...listaMotivosTipo].map((obj, i) => {
                                    return (
                                        <MenuItem value={obj}>{obj}</MenuItem>
                                    )
                                })}
                            </TextField>
                        </div>

                        <div className="col-sm-12">
                            <TextField
                                multiline
                                minRows={2}
                                label="Motivo de cancelamento *"
                                margin="normal"
                                variant="outlined"
                                onChange={(e) => this.setState({ motivo: e.target.value })}
                                value={this.state.motivo}
                            />
                        </div>

                        <div className="col-sm-12">
                            <TextField
                                type="date"
                                InputLabelProps={{ shrink: true }}
                                name="ctr_data_inicio_vigencia"
                                label="Data de cancelamento *"
                                margin="normal"
                                variant="outlined"
                                onChange={(e) => this.setState({ data_de_cancelamento: e.target.value })}
                                value={this.state.data_de_cancelamento}
                            />
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <button
                        disabled={this.state.submitted}
                        type="button"
                        className="btn btn-danger btn-bold"
                        onClick={() => setOpen(false)}
                    >
                        <i className={`margin-icon ${this.state.submitted ? "fas fa-sync fa-spin" : "fa fa-window-close"}`}></i>
                        Cancelar
                    </button>

                    <button
                        type="button"
                        disabled={this.state.submitted}
                        className="btn btn-success btn-bold pull-right"
                        onClick={this.onSubmit}
                    >
                        <i className={`margin-icon ${this.state.submitted ? "fas fa-sync fa-spin" : "fa fa-check-square"}`}></i>
                        Inativar contrato(s)
                    </button>
                </Modal.Footer>
            </Modal>
        );
    }
}
